module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech_m.da432635ebebeb0750a48e4d8e71b6d7.png";